import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FiClipboard, FiGrid, FiPlusCircle, FiLogOut } from 'react-icons/fi';
import { useAuth } from '../../context';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/Header.css';

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const { logout, displayName } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const isActive = (path) => location.pathname === path;

  // Keyboard navigation for mobile menu
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleNavCollapse();
    }
  };

  return (
    <nav
      className="navbar navbar-expand-md navbar-light bg-white sticky-top"
      role="navigation"
      aria-label="Main navigation"
    >
      <div className="container">
        {/* Skip to main content link for accessibility */}
        <a
          href="#main-content"
          className="skip-link visually-hidden-focusable"
        >
          Skip to main content
        </a>

        {/* Brand */}
        <Link
          className="navbar-brand d-flex align-items-center"
          to="/taskBoard"
          aria-label="Task Manager - Go to task board"
        >
          <FiClipboard className="brand-icon me-2" aria-hidden="true" />
          <span className="brand-text">Task Manager</span>
        </Link>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded={!isNavCollapsed}
          aria-label={isNavCollapsed ? "Open navigation menu" : "Close navigation menu"}
          onClick={handleNavCollapse}
          onKeyDown={handleKeyDown}
        >
          <span className={`hamburger ${!isNavCollapsed ? 'active' : ''}`} aria-hidden="true">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>

        {/* Navigation Links */}
        <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-center" role="menubar">
            <li className="nav-item" role="none">
              <Link
                className={`nav-link ${isActive('/taskBoard') ? 'active' : ''}`}
                to="/taskBoard"
                onClick={() => setIsNavCollapsed(true)}
                role="menuitem"
                aria-current={isActive('/taskBoard') ? 'page' : undefined}
              >
                <FiGrid className="nav-icon" aria-hidden="true" />
                Task Board
              </Link>
            </li>
            <li className="nav-item" role="none">
              <Link
                className={`nav-link ${isActive('/create') ? 'active' : ''}`}
                to="/create"
                onClick={() => setIsNavCollapsed(true)}
                role="menuitem"
                aria-current={isActive('/create') ? 'page' : undefined}
              >
                <FiPlusCircle className="nav-icon" aria-hidden="true" />
                Create Task
              </Link>
            </li>
            <li className="nav-item ms-md-3" role="none">
              <button
                className="btn btn-logout"
                onClick={handleLogout}
                aria-label={`Logout ${displayName}`}
              >
                <FiLogOut className="logout-icon" aria-hidden="true" />
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}